<template>
  <div class="app-img-preview-mask" @click="remove">
    <div class="app-img-preview-body">
      <!--      <img ref="img" class="app-img-preview-img" :src="src" alt="">-->
      <canvas ref="cvs" class="app-img-preview-img" />

      <div class="app-img-preview-btn mt16" v-if="showButton !== false">
        <el-button @click="download">下载</el-button>
        <el-button>确认</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'baseImgPreview',
  // props: ['src', 'id', 'showButton'],
  props: {
    src: {
      type: String,
      default: () => ''
    },
    id: {
      type: [String, Number]
    },
    showButton: {
      type: Boolean,
      default: () => true
    },
    size: {
      //fit:适应
      type: String
    }
  },
  data() {
    return {
      img: null
    };
  },
  methods: {
    remove() {
      this.$emit('close');
    },
    download() {
      let link = document.createElement('a');
      link.href = this.$refs.cvs.toDataURL('image/png');
      link.download = `发票_${this.id}.png`;
      link.click();
    }
  },
  mounted() {
    const cvsRef = this.$refs.cvs;
    const img = new Image();
    const size = this.size;

    img.src = this.src;
    img.crossOrigin = '';
    let ctx = cvsRef.getContext('2d');
    img.onload = () => {
      cvsRef.width = window.innerWidth * 0.8;
      cvsRef.height = window.innerHeight * 0.8;
      // 缩放比例
      const scale = img.height / cvsRef.height;

      if (size === 'fit') {
        ctx.drawImage(
          img,
          (cvsRef.width - img.width / scale) / 2,
          0,
          img.width / scale,
          cvsRef.height
        );
        return;
      }
      ctx.drawImage(img, 0, 0, cvsRef.width, cvsRef.height);
    };
  }
};
</script>

<style scoped lang="scss">
.app-img-preview {
  &-mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9991;
  }
  &-body {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
